import React, { useState, useEffect } from 'react';
import { Fab } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { animateScroll as scroll } from 'react-scroll';
import { motion } from 'framer-motion';
import "../styles/Navbar.css";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    scroll.scrollToTop({
      duration: 100,
      smooth: 'easeInOutQuint',
    });
  };

  return visible ? (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='scrooltotop'
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        zIndex: 1000,
      }}
    >
      <Fab
        color="primary"
        aria-label="scroll back to top"
        onClick={scrollToTop}
        className='scroltotop'
        style={{backgroundColor:'rgb(14,89,145)'}}
        sx={{
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
          '&:hover': {
            transform: 'scale(1.1)',
          },
          transition: 'transform 0.2s',
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </motion.div>
  ) : null;
};

export default ScrollToTopButton;